import React from 'react'
import { SelectBox } from 'components'

export const SUB_CHANNEL_DROPDOWN_OPTIONS = [
  { value: 'all', text: 'All' },
  { value: 'mfg', text: 'MFG' },
  { value: 'non-mfg', text: 'Non-MFG' },
]

type WholesaleSubChannelState = {
  subChannelState: { sku: string[]; subChannel: string }
  onChange(subChannel: string): void
}

export const SelectWholesaleSubChannel = (props: WholesaleSubChannelState) => {
  const { subChannelState, onChange } = props
  const { sku, subChannel } = subChannelState

  const isEnabled = !!sku.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (!subChannel) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleSubChannelChange = (selectedSubChannel: string) => {
    onChange(selectedSubChannel)
  }

  return (
    <div className="w-full sm:w-64">
      <SelectBox
        placeholder="Select sub-channel"
        label="Sub-channel *"
        id="sub-channel"
        disabled={!isEnabled}
        value={subChannel}
        onChange={handleSubChannelChange}
        options={SUB_CHANNEL_DROPDOWN_OPTIONS}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
